import { Form, FormGroup, FormFeedback, Alert, Spinner } from "reactstrap";
import { AuthButton, AuthContainer, AuthInput } from "./style";
import Link from "../common/Link";
import { login, setAuthenticatedUser } from "./service";
import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { CoreContainer } from "../common/style";
import { isMobile } from "react-device-detect";
import { AppContext } from "../context";

function Login({ user }) {
  const navigate = useNavigate();
  const [mobileNumber, setMobileNumber] = useState("");
  const [password, setPassword] = useState("");
  const [code, setCode] = useState("");
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { setOrganizationData } = useContext(AppContext);
  const enableLogin =
    mobileNumber.length === 10 &&
    /^\d+$/.test(mobileNumber) &&
    (code.length > 0 || password.length > 0);

  function doLogin() {
    setIsLoading(true);

    login({ mobileNumber, password, code })
      .then(({ token, user, plan_features }) => {
        setAuthenticatedUser({ token, user });
        setOrganizationData(plan_features);
        navigate("/projects", {
          state: { setIdentity: true },
        });
      })
      .catch(({ error }) => {
        setError(error);
      })
      .finally((_) => setIsLoading(false));
  }

  return (
    <CoreContainer height={isMobile ? "unset" : null}>
      <AuthContainer className="px-4 px-sm-5 pt-4 pb-2 rounded-3">
        <h4 className="text-center mt-2"> LOGIN </h4>
        <Form>
          <FormGroup>
            <AuthInput
              invalid={
                mobileNumber.length > 0 &&
                (mobileNumber.length !== 10 || !/^\d+$/.test(mobileNumber))
              }
              type="text"
              value={mobileNumber}
              placeholder="Mobile Number"
              onChange={(ev) => setMobileNumber(ev.target.value)}
            />
            <FormFeedback>Please enter a valid Mobile number.</FormFeedback>
          </FormGroup>
          {user ? (
            <FormGroup>
              <AuthInput
                type="password"
                value={code}
                placeholder="Code"
                onChange={(ev) => setCode(ev.target.value)}
              />
            </FormGroup>
          ) : (
            <FormGroup>
              <AuthInput
                type="password"
                value={password}
                placeholder="Password"
                onChange={(ev) => setPassword(ev.target.value)}
              />
            </FormGroup>
          )}
          {error && <Alert color="danger">{error} &nbsp;</Alert>}
          <div className="d-grid gap-2 mt-4 mb-3 pt-3">
            <AuthButton
              onClick={doLogin}
              disabled={!enableLogin || isLoading}
              color="primary"
            >
              {isLoading ? (
                <>
                  <Spinner size="sm">Loading...</Spinner> &nbsp;
                  <span>Loading...</span>
                </>
              ) : (
                "Login"
              )}
            </AuthButton>
          </div>
          {!user && (
            <p className="text-center">
              <Link
                to="/login_with_otp"
                children="Login using OTP?"
                fontWeight="700"
                color="black"
              />
            </p>
          )}
          {!user && (
            <p className="text-center">
              Don't have an account? &nbsp;
              <Link
                to="/register"
                children="Register Here"
                fontWeight="700"
                color="black"
              />
            </p>
          )}
        </Form>
      </AuthContainer>
    </CoreContainer>
  );
}

export default Login;
